'use client';

import React, { FC } from 'react';

import { Box, Button, Stack } from '@mantine/core';

import { URLHelpers } from 'helpers/URLHelpers';

import cx from 'components/page/Hero.module.scss';
import { Title } from 'components/page/Title';

const NotFound: FC<{ message?: string }> = ({ message }) => (
    <Box
        mih="calc(100dvh - var(--header-height))"
        style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }}
        className={cx.hero}
    >
        <video
            src={URLHelpers.file('/videos/dcide-header.mp4')}
            width={3840}
            height={2160}
            autoPlay
            loop
            muted
            playsInline
            style={{ pointerEvents: 'none' }}
        />
        <Stack align="center" gap={40}>
            <Title fz={40} ta="center" c="white">
                {message || "Hmm… this page doesn't exist"}
            </Title>

            <Button variant="white" size="lg" component="a" href="/">
                Go back to home
            </Button>
        </Stack>
    </Box>
);

export { NotFound };
